import React from 'react';

import {
  Swiper as DynamicSwiper,
  Slide as DynamicSlide,
} from 'react-dynamic-swiper';
import 'react-dynamic-swiper/lib/styles.css';
import classNames from 'classnames';

interface SwiperProps {
  /** List of SwiperSlides. */
  children: React.ReactElement[];
  /** CSS class name. */
  className?: string;
  /** Headline for the slider. */
  header?: React.ReactNode;
}

/** Displays a Swiper with Slides as children. */
const Swiper = ({ children, className, header }: SwiperProps) => {
  const items = children.map((item, index) => {
    return <DynamicSlide key={`index${index + 1}`}>{item}</DynamicSlide>;
  });

  return (
    <div className={classNames(className, 'ce ce-swiper')}>
      {header}
      <DynamicSwiper
        className="ce ce-swiper-wrapper"
        swiperOptions={{
          autoHeight: true,
        }}
      >
        {items}
      </DynamicSwiper>
    </div>
  );
};

Swiper.defaultProps = {
  className: null,
  header: null,
};

export default Swiper;
